import React, { useEffect, useState } from "react";
import { getEmployeeStatsData } from "../Services/ApiCalling";
import EmployeeLeave from "./component/EmployeeLeave";


function EmpStatsView() {
  return (
    <>
      <EmployeeLeave />
    </>
  );
}

export default EmpStatsView;
